import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ListCampaignsApiArg } from '@/__generated/es-api'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import config from '@/config'

const DEFAULT_PAGE_SIZE = config.modules.campaigns.pageSize.default

export const useGetCampaigns = (query: Omit<ListCampaignsApiArg, 'orgId'>) => {
  const orgId = useSelector(selectOrgId)

  const params = useMemo(() => {
    const {
      page = 1,
      size = DEFAULT_PAGE_SIZE,
      templates,
      search,
      archived,
      aborted,
      open,
      published,
      launched,
    } = query

    return {
      page,
      size,
      templates,
      search,
      archived: archived ? undefined : false,
      aborted,
      open,
      published,
      launched,
    }
  }, [query])

  return esApi.endpoints.listCampaigns.useQuery(
    {
      orgId: orgId?.toString(),
      ...params,
    },
    { skip: !orgId },
  )
}
